import React from 'react';
import {
  ThemeProvider as EmotionThemeProvider,
  ThemeProviderProps as EmotionThemeProviderProps,
  Global,
} from '@emotion/react';
import { CoreTheme } from '../theming/core';
import normalize from '../theming/css-modules/normalize.module.css';
export interface ThemeProviderProps extends EmotionThemeProviderProps {
  theme: CoreTheme;
  addGlobalStyles?: boolean;
  addNormalization?: boolean;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = React.memo(
  ({
    theme,
    addGlobalStyles = false,
    addNormalization = false,
    children,
  }: ThemeProviderProps) => {
    const { global, ..._theme } = theme;
    return (
      <EmotionThemeProvider theme={_theme}>
        {addGlobalStyles && <Global styles={global} />}
        {addNormalization && <Global styles={`${normalize}`} />}
        {children}
      </EmotionThemeProvider>
    );
  },
);

export default ThemeProvider;
